// Maintaining the sequence is very important
export enum SetupWizardSteps {
  Welcome,
  TerritoryStructure,
  OrganizationStructure,
  RoleStructure,
  SummaryReview,
}

